/* eslint-disable */

export interface Reaction {
  type?: ReactionType;
  data?: string;
  created_at?: number;
  customer_token?: string;
}

export enum ReactionType {
  EMOJI = "EMOJI",
}
